import axios from 'axios';
import { BaseService } from './BaseService';

export class ResidenceService extends BaseService {

    async getResidences() {
        return this.get(`/residences`, true);
    }

}